import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Chapters from "@/components/site/Chapters";
import Inventory from "@/components/site/Inventory";
import ValuationForm from "@/components/site/ValuationForm";
import OfferForm from "@/components/site/OfferForm";
import TrackCTA from "@/components/site/TrackCTA";
import Socials from "@/components/site/Socials";
import Footer from "@/components/site/Footer";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, anchors: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <main className="bg-[#F3EDE3] text-[#0A0A0A] font-sans antialiased overflow-x-clip" data-testid="home-page">
      <div className="noise-layer" />
      <Navbar />
      <Hero />
      <Marquee />
      <Chapters />
      <Inventory />
      <ValuationForm />
      <OfferForm />
      <TrackCTA />
      <Socials />
      <Footer />
    </main>
  );
}
